import { render } from "./InfoMap.vue?vue&type=template&id=0b9ddabc&scoped=true"
import script from "./InfoMap.vue?vue&type=script&lang=js"
export * from "./InfoMap.vue?vue&type=script&lang=js"

import "./InfoMap.vue?vue&type=style&index=0&id=0b9ddabc&scoped=true&lang=css"

import exportComponent from "/home/jbenes/PhpstormProjects/VUE/VUE_Neustadt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9ddabc"]])

export default __exports__